module.exports = __webpack_public_path__ + "img/gszz.522480f5.jpg";